import * as React from 'react';
import { connect } from 'react-redux';

import { DataRequestActionTypes } from '../../constants/actionTypes';
import { FormId } from '../../constants/formId';
import { baseMapDispatchToProps, baseMapStateToProps, ComponentBase } from '../componentBase';
import AppForm from '../form/appForm';
import { AppTextField } from '../form/appTextField';
import { passwordValidator, required } from '../form/formValidations';

import styles from './changePassword.module.scss';

interface ChangePasswordOwnProps {
  displayText?: string;
  changeMyPassword?: boolean;
  userId: string;
}

export class ChangePassword extends ComponentBase<ChangePasswordOwnProps> {
  public loggedInRender(): JSX.Element | string {
    return (
      <div className={styles.changePassword}>
        <h3 className={styles.centerFormInfo}>{this.props.displayText}</h3>
        <AppForm
          form={FormId.ChangePasswordForm}
          submitActionType={DataRequestActionTypes.ChangePasswordRequested}
          validate={this.validateForm}
          submitText="Submit"
          reduxData={{
            userId: `${this.props.userId}`,
          }}
          redirectToPathAfterSubmit={this.props.changeMyPassword ? '/' : '/users'}
          className={styles.changePasswordForm}
        >
          {this.props.changeMyPassword && (
            <AppTextField name="oldPassword" label="Old Password" validate={[required]} type="password" />
          )}
          <AppTextField
            name="newPassword"
            label="New Password"
            validate={[required, passwordValidator]}
            type="password"
          />
          <AppTextField name="confirmNewPassword" label="Confirm New Password" validate={[required]} type="password" />
        </AppForm>
      </div>
    );
  }

  private validateForm = (values: any) => {
    const errors: any = {};

    if (values.newPassword && values.confirmNewPassword && values.newPassword !== values.confirmNewPassword) {
      errors.confirmNewPassword = 'Password does not match!';
    }

    return errors;
  };
}

export default connect(baseMapStateToProps, baseMapDispatchToProps)(ChangePassword);
